import { PiMagnifyingGlass } from 'react-icons/pi'
import { cn } from 'components/UI/cn'

interface QuickFilterSearchProps {
  value: string
  onChange: (value: string) => void
  placeholder?: string
  className?: string
}

/**
 * Compact search box for the board's quick-filter dropdowns (Owner, Visible
 * Stages). Keystrokes are stopped from bubbling so Radix's menu typeahead
 * doesn't hijack them (which would move focus to a menu item and/or close the
 * popover mid-search).
 */
export function QuickFilterSearch({
  value,
  onChange,
  placeholder = 'Search',
  className,
}: QuickFilterSearchProps) {
  return (
    <div
      className={cn(
        'flex items-center gap-2 rounded-md border border-neutral-200 px-2.5 py-1.5',
        className
      )}
    >
      <PiMagnifyingGlass className="size-4 flex-shrink-0 text-fg-secondary" />
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={(e) => e.stopPropagation()}
        placeholder={placeholder}
        className="flex-1 border-none bg-transparent text-sm text-fg outline-none placeholder:text-fg-muted"
      />
    </div>
  )
}
